import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/Services/User/user.service';
import { ToastService } from 'src/app/Services/toast/toast.service';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forme!: FormGroup;
  submitted = false;
  email: any;
  disable='' ; 
  user: any;
  msg = '';
  siteKey: string = "6LfsTZMfAAAAAIY_FlP17PVhGHxBcMohV5Xx8n0p";

  constructor(private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toast: ToastService
    ) { }

    ngOnInit(): void {
     
      this.forme = this.formBuilder.group({
        email: ['', [Validators.required, Validators.email]],
      });
    }

  

  sendEmail() {
    this.disable='';
  console.log(this.forme.value.email);
    this.userService.generateOTP(this.forme.value.email).subscribe(
      (data) => {
        
        this.email = data;
        localStorage.setItem('email', this.forme.value.email);
        this.toast.SuccessToast('code send to your email Check your spam as well');
        this.router.navigate(['/otpPassword']);
        this.disable='';
        return this.email;
      },
      (error) => {
        this.disable = 'Error';
        this.msg = "Faild !"
        this.toast.ErrorToast("Please verify your email !");
      }
    );
  }
}
